import { Box, IconButton, Modal, useTheme } from '@mui/material';
import Button from 'components/Button';
import { ICONS } from 'components/Icon/icons';
import Text from 'components/Text';

type BypassFraudCheckModalProps = {
  isOpen: boolean;
  onClose: () => void;
  bypassEnabled: boolean;
  onStateChange: (enabled: boolean) => void;
  isLoading: boolean;
};

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '500px',
  bgcolor: 'background.paper',
  border: '1px solid #2356F6',
  borderRadius: '5px',
  boxShadow: 24,
  p: '24px 20px',
  display: 'flex',
  flexDirection: 'column',
  gap: '18px'
};

const BypassFraudCheckModal = ({
  isOpen,
  onClose,
  bypassEnabled,
  onStateChange,
  isLoading
}: BypassFraudCheckModalProps) => {
  const theme = useTheme();

  const onConfirm = () => {
    onStateChange(!bypassEnabled);
    onClose();
  };

  return (
    <Modal open={isOpen} onClose={onClose}>
      {bypassEnabled ? (
        <Box sx={modalStyle}>
          <Text variant="h1" component="h2">
            Enable Fraud Protection
          </Text>
          <IconButton
            sx={{
              position: 'absolute',
              padding: 0,
              top: '20px',
              right: '12px',
              color: theme.palette.grey[500]
            }}
            onClick={onClose}
          >
            <ICONS.CLOSE_MODAL />
          </IconButton>
          <Text variant="body">
            This will enable programmatic fraud checks for donations made
            through this form.
          </Text>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '12px',
              justifyContent: 'center'
            }}
          >
            <Button
              size="small"
              variant="secondary"
              onClick={onClose}
              sx={{ width: '120px' }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              onClick={onConfirm}
              sx={{ width: '160px', padding: 0 }}
            >
              Enable Fraud Protection
            </Button>
          </Box>
        </Box>
      ) : (
        <Box sx={modalStyle}>
          <Text variant="h1" component="h2">
            Bypass Fraud Protection?
          </Text>
          <IconButton
            sx={{
              position: 'absolute',
              padding: 0,
              top: '20px',
              right: '12px',
              color: theme.palette.grey[500]
            }}
            onClick={onClose}
          >
            <ICONS.CLOSE_MODAL />
          </IconButton>

          <Box
            sx={{
              bgcolor: '#FFCC00',
              border: '1px solid #B47D30',
              borderRadius: '3px',
              padding: '12px'
            }}
          >
            <Text variant="body">
              <strong>Important:</strong> Bypassing fraud protection increases
              the risk of fraudulent transactions. By proceeding, you
              acknowledge and accept this heightened security risk.
            </Text>
          </Box>
          <Text variant="body">
            Enabling this feature will disable programmatic fraud checks for
            donations made through this form.
          </Text>
          <Text variant="body">
            This is intended solely for authorized call center operators
            entering donation information provided by donors over the phone.
          </Text>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'row',
              gap: '12px',
              justifyContent: 'center'
            }}
          >
            <Button
              size="small"
              variant="secondary"
              onClick={onClose}
              sx={{ width: '120px' }}
            >
              Cancel
            </Button>
            <Button
              size="small"
              onClick={onConfirm}
              sx={{ width: '120px', padding: 0 }}
              disabled={isLoading}
            >
              Enable Bypass
            </Button>
          </Box>
        </Box>
      )}
    </Modal>
  );
};

export default BypassFraudCheckModal;
